export default [
    {
        "id": "customer-profile",
        "plugin": "CustomerProfile",
        "pluginId": 11,
        "name": "customer-profile",
        "config": `{"GET_orderPageId":"ordPageId","GET_orderId":"orderId","GET_reviewPageId":"rvPageId","GET_reviewAwaitingPageId":"rvAwPageId","GET_historyPageId":"hsPageId","GET_complaintsPageId":"complaintsPageId","GET_complaintId":"complaintId"}`,
        "html": require('./customer-profile/html').default,
        "js": require('./customer-profile/js').default,
        "minJs": require('./customer-profile/minJs').default,
        "css": require('./customer-profile/css').default,
        "cssTablet": require('./customer-profile/cssTablet').default,
        "cssMobile": require('./customer-profile/cssMobile').default,
        "scss": require('./customer-profile/scss').default,
        "scssTablet": require('./customer-profile/scssTablet').default,
        "scssMobile": require('./customer-profile/scssMobile').default,
        "pages": 'CustomerProfile'
    }
]